import React, { useEffect, useState } from 'react';
import Service from '../Service/Service';
// import './Services.css';

const Services = () => {
    const [services, setServices] = useState([])
    const [show, setShow] = useState('none');
    useEffect(() => {
        setShow('block')
        fetch('https://bloodcurdling-corpse-74480.herokuapp.com/users')
            .then(res => res.json())
            .then(data => {
                setServices(data);
                setShow('none');
            });
    }, [])

    return (
        <div id="services" className=" my-3">
            <h1 className="text-primary mt-5 fw-bold">Our Services</h1><br />
            <div style={{ display: show }}>
                <div class="spinner-border" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>



            <div className="container">

                <div className="row">
                    {
                        services.map(service => <Service
                            key={service._id}
                            service={service}
                        ></Service>)
                    }
                </div>

            </div>
        </div>
    );
};

export default Services;